module.exports = __webpack_public_path__ + "static/media/resend_email.cd6b4c4d.svg";